import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Paper, Typography } from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { formatDate } from "../../utils/CurrencyFormat";

export default function ContactPage() {
  const [rows, setRows] = React.useState([]);
  const [totalItems, setTotalItems] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    { field: "fullName", headerName: "Tên người liên hệ", flex: 3 },
    { field: "email", headerName: "Email", flex: 3 },
    { field: "phone", headerName: "Số điện thoại", flex: 3 },
    // { field: "email", headerName: "Email", flex: 3 },
    { field: "message", headerName: "Lời nhắn", flex: 3 },
    {
      field: "createdAt",
      headerName: "Ngày liên hệ",
      flex: 3,
      renderCell: (params) => {
        return <span>{formatDate(params.value)}</span>;
      },
    },
  ];

  React.useEffect(() => {
    getData();
  }, [paginationModel]);

  const getData = () => {
    axios
      .get(`/api/v1/contacts`, {
        params: {
          page: paginationModel.page,
          limit: paginationModel.pageSize,
          paginationAdmin: true,
        },
      })
      .then((res) => {
        setRows(res.data.contacts);
        setTotalItems(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
    parentId: row.parentId == 0 ? "" : row.parentId,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý người liên hệ
      </Typography>
      <Box
        sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}
      ></Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          columns={columns}
          rowHeight={150}
          rowCount={totalItems}
          pagination
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) =>
            setPaginationModel(newPaginationModel)
          }
          initialState={{
            pagination: {
              paginationModel: paginationModel,
            },
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>
    </Box>
  );
}
